import { h, clear } from '../dom.js';
import type { Sentence } from '../types.js';

export interface SentenceCardHandle {
  root: HTMLElement;
  setSentence: (s: Sentence | null, index: number, total: number) => void;
  setEmpty: (msg: string) => void;
}

// Card structure (fixed height, no animation, no label / counter):
//   .sc
//     .sc__jp   (1 line, ellipsis for long text — keeps height stable)
//     .sc__zh   (fixed 2 lines)
//     .sc__gr   (single row, hidden overflow)
//     .sc__empty (fallback text overlay)
export function createSentenceCard(): SentenceCardHandle {
  const jp = h('div', { className: 'sc__jp' });
  const zh = h('div', { className: 'sc__zh' });
  const gr = h('div', { className: 'sc__gr' });
  const empty = h('div', { className: 'sc__empty', text: '' });

  const root = h('article', { className: 'sc' }, [jp, zh, gr, empty]);

  function renderContent(s: Sentence): void {
    empty.textContent = '';
    empty.style.display = 'none';
    jp.textContent = s.text;
    zh.textContent = s.translation;
    clear(gr);
    for (const g of s.grammar) {
      const chip = h(
        'span',
        {
          className: 'gr-chip',
          attrs: { title: g.type ?? '' },
        },
        [
          h('b', { text: g.word }),
          g.meaning ? h('span', { className: 'gr-chip__meaning', text: g.meaning }) : null,
        ],
      );
      gr.appendChild(chip);
    }
  }

  function setSentence(s: Sentence | null, _index: number, _total: number): void {
    if (!s) {
      empty.style.display = 'none';
      jp.textContent = '';
      zh.textContent = '';
      clear(gr);
      return;
    }
    renderContent(s);
  }

  function setEmpty(msg: string): void {
    jp.textContent = '';
    zh.textContent = '';
    clear(gr);
    empty.textContent = msg;
    empty.style.display = 'block';
  }

  return { root, setSentence, setEmpty };
}
